
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/exhibition",
      function () {
        return require("private-next-pages/admin/exhibition/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/exhibition"])
      });
    }
  